import { Typography, Box, Container } from '@mui/material';
import ResponsiveAppBar from './ResponsiveAppBar';
import Footer from "./Footer";
import Contactform from './Contactform';
import '../App.css';

const Notar = () => {
  return (
    <div className="App">

      <main>

      <ResponsiveAppBar />

        <Container maxWidth="lg" className="container serviceContainer">
          <Typography variant='h2' className='sectionTitle'>Unser Team</Typography>

          <Box className="teamGrid">

            <Box className="teamItem">
                <Box className="teamImgWrapper">
                  <img src='team/Astrid-Becker.webp' className='teamImg' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Astrid Becker</b></Typography>
                  <Typography variant='body1'>Empfang</Typography>
                </Box>
            </Box>
            
            <Box className="teamItem">
                <Box className="teamImgWrapper">
                  <img src='team/Placeholder-Profile.png' className='teamImg' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Bärbel Holtorf</b></Typography>
                  <Typography variant='body1'>Empfang</Typography>
                </Box>
            </Box>
            
            <Box className="teamItem">
                <Box className="teamImgWrapper">
                  <img src='team/Diana-Ernst.webp' className='teamImg' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Diana Ernst </b></Typography>
                  <Typography variant='body1'>Notarfachassistentin</Typography>
                </Box>
            </Box>
            <Box className="teamItem">
                <Box className="teamImgWrapper">
                  <img src='team/Natalia-Gusdek.webp' className='teamImg' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Natalia Gusdek</b></Typography>
                  <Typography variant='body1'>Notarfachwirtin</Typography>
                </Box>
            </Box>
            <Box className="teamItem">
                <Box className="teamImgWrapper">
                  <img src='team/Romina-Harder.webp' className='teamImg' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Romina Harder</b></Typography>
                  <Typography variant='body1'>Auszubildende</Typography>
                </Box>
            </Box>
            <Box className="teamItem">
                <Box className="teamImgWrapper">
                  <img src='team/Alexandra-Koenig.webp' className='teamImg' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Alexandra König </b></Typography>
                  <Typography variant='body1'>Notarfachangestellte</Typography>
                </Box>
            </Box>
            <Box className="teamItem">
                <Box className="teamImgWrapper">
                  <img src='team/Stefan-Palenberg.webp' className='teamImg' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Stefan Palenberg</b></Typography>
                  <Typography variant='body1'>Notarfachassistent</Typography>
                </Box>
            </Box>
            <Box className="teamItem">
                <Box className="teamImgWrapper">
                  <img src='team/Suzan-Siegberg.webp' className='teamImg' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Suzan Siegberg</b></Typography>
                  <Typography variant='body1'>Notarfachangestellte</Typography>
                </Box>
            </Box>
            <Box className="teamItem">
                <Box className="teamImgWrapper">
                  <img src='team/Vita-Sorychta-Mehrabani.webp' className='teamImg' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Vita Sorychta-Mehrabani</b></Typography>
                  <Typography variant='body1'>Notarfachangestellte</Typography>
                </Box>
            </Box>
            <Box className="teamItem">
                <Box className="teamImgWrapper">
                  <img src='team/Melanie-Vilshoever.webp' className='teamImg' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Melanie Vilshöver</b></Typography>
                  <Typography variant='body1'>Notarfachangestellte</Typography>
                </Box>
            </Box>
            <Box className="teamItem">
                <Box className="teamImgWrapper">
                  <img src='team/Anika-Wiwiorra.webp' className='teamImg' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Anika Wiwiorra</b></Typography>
                  <Typography variant='body1'>Notarfachassistentin - in Elternzeit</Typography>
                </Box>
            </Box>


          </Box>

        </Container>

 <Box className="map" id="map">
                                <Box className="contactMap">

                                    {/* <iframe width="100%" height="100%" frameBorder="0" allowFullScreen allow="geolocation" src="//umap.openstreetmap.de/en/map/notare-harbecke-thelen_85729?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=true&searchControl=false&tilelayersControl=null&embedControl=false&datalayersControl=null&onLoadPanel=none&captionBar=false&captionMenus=false&captionControl=null&locateControl=null&measureControl=null"></iframe> */}

                                    <a href="https://www.google.com/maps/dir//Notarin%20Dr.%20Antonia%20Harbecke,%20Holzgasse%2029-33,%2053721%20Siegburg" target="_blank" class="contactMapLink">
                                        <img src="HT-Karte.jpg" className="contactMapImg" />
                                        <a href="http://openstreetmap.org/copyright" target="_blank" className="mapSource">©OpenStreetMap</a>
                                    </a>
                                    <Container maxWidth="lg" className="container">
                                        <Typography variant='body1' paragraph className="contactMapAddress">
                                            Wenn Sie auf den Link klicken, verlassen Sie unsere Webseite und werden auf Google Maps (ein Service der Google Ireland Limited Gordon House, Barrow Street Dublin 4, Irland) weitergeleitet. Weitere Informationen zu Zweck und Umfang der Datenerhebung und ihrer Verarbeitung erhalten Sie in den Datenschutzerklärungen von <a href="http://www.google.de/intl/de/policies/privacy" target="_blank">Google</a>.
                                        </Typography>
                                    </Container>
                                    
                                </Box>
                                {/* <Container maxWidth="lg" id="routelink">
                                    <Typography variant='body1' paragraph className="contactMapRouteLink">Einen Routenplaner finden sie <a href="https://www.google.com/maps/dir//Notarin%20Dr.%20Antonia%20Harbecke,%20Holzgasse%2029-33,%2053721%20Siegburg" target="_blank">hier</a>.</Typography>
                                </Container> */}

                            </Box>


                      <Box className="section bannergrey" id="kontakt">
                                <Container maxWidth="lg" className="container" id="kontakt">
                                    <Box className="kontaktGrid">
                                        <Box className="kontaktLeftSide smaller">
                                            <Typography variant='h2' className='sectionTitle white small'>
                                                Sie haben Fragen?  <br />
                                                Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Öffnungszeiten</b><br />
                                                Montag bis Freitag von 8:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                                                Mittwoch ab 13:00 Uhr geschlossen<br />
                                                Spätere Termine sind nach Vereinbarung möglich<br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Telefon</b><br />
                                                Sie erreichen uns unter: 02241 66444<br />
                                                Montag bis Freitag von 9:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                                                Mittwoch nur bis 13:00 Uhr. <br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>E-mail: info@ht-notare.de</b><br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Fax: 02241 55161</b><br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Anfahrt und Parkmöglichkeiten</b><br />
                                                Das Büro befindet sich im Zentrum von Siegburg in der Holzgasse Nr. 29 – 33. Die Kanzleiräume liegen in der ersten Etage und sind mittels eines Aufzugs und Treppenlifts barrierefrei zugängig. <br />
                                                Parkmöglichkeiten befinden sich u.a. im Parkhaus Holzgasse in unmittelbare Nähe zu den Kanzleiräumlichkeiten sowie im Parkhaus von Galeria Kaufhof und Saturn, etwa 100 Meter entfernt.
                                            </Typography>
                                        </Box>
                                        <Contactform />
                                    </Box>
                                </Container>
                            </Box>


      </main >
      <Footer />
    </div >
  );
}

export default Notar;